import type { WeeklySlot } from './types';

const TIME_LOCAL_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

export const DEFAULT_WEEKLY_SLOT: WeeklySlot = { weekday: 0, timeLocal: '09:00', endTimeLocal: '10:00' };

export function isValidWeeklySlot(slot: WeeklySlot): boolean {
  return Number.isInteger(slot.weekday)
    && slot.weekday >= 0 && slot.weekday <= 6
    && TIME_LOCAL_PATTERN.test(slot.timeLocal)
    && (slot.endTimeLocal === undefined || (
      TIME_LOCAL_PATTERN.test(slot.endTimeLocal) && slot.endTimeLocal >= slot.timeLocal
    ));
}

export function parseWeeklySlots(value: unknown): WeeklySlot[] {
  if (!Array.isArray(value)) return [];
  return value.flatMap((item): WeeklySlot[] => {
    if (!item || typeof item !== 'object') return [];
    const record = item as Record<string, unknown>;
    const timeLocal = record.timeLocal ?? record.time_local;
    if (typeof timeLocal !== 'string'
      || (record.endTimeLocal !== undefined && typeof record.endTimeLocal !== 'string')) return [];
    const slot: WeeklySlot = {
      weekday: Number(record.weekday), timeLocal,
      ...(record.endTimeLocal === undefined ? {} : { endTimeLocal: record.endTimeLocal as string }),
    };
    return isValidWeeklySlot(slot) ? [slot] : [];
  });
}

export function weeklySlotTimeLabel(slot: WeeklySlot): string {
  return slot.endTimeLocal && slot.endTimeLocal !== slot.timeLocal
    ? `${slot.timeLocal}–${slot.endTimeLocal}` : slot.timeLocal;
}

export function timeToMinutes(time: string): number {
  const [hour, minute] = time.split(':').map(Number);
  return hour * 60 + minute;
}
